import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Container,
  Typography,
  Rating,
  TextField,
  Button,
  Box,
  Paper,
  Divider,
  styled,
  Grid
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import LandingCurrentDateTime from "../LandingCurrentDateTime";
// ================================================================

const FullScreenContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  minHeight: '100vh', // Ensure it fills the viewport height
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'auto', // Allows scrolling if content overflows
  // backgroundColor: 'gray', 
  // backgroundImage: `url(/assets/images/bookonline-bg1.jpg)`,
  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5),rgba(0, 0, 0, 0.5)),url("/assets/images/bookonline-bg.jpeg")`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'repeat',
  backgroundAttachment: 'fixed'
}));
const LogoBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "20px",
  left: "20px",
  backgroundColor: "#fff",
  padding: "10px 12px",
  borderRadius: "8px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
  zIndex: 99
}));

const Root = styled(Paper)(({ theme }) => ({
  margin: theme.spacing(3),
  padding: theme.spacing(3),
  backgroundColor: 'rgba(255, 255, 255,0.8)',
  //borderRadius: theme.spacing(2),
}));

const Section = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: theme.spacing(3),
}));

const CustomDivider = styled(Divider)(({ theme }) => ({
  marginTop: theme.spacing(2), // Adjust margin top
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.primary.main, // Custom background color
}));

const CustomRatingDivider = styled(Divider)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const fetchServices = async (ticketIdFromUrl) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_FSERVER}/api/feedback/check?ticketId=${ticketIdFromUrl}`);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data; // Return fetched data

  } catch (error) {
    console.error("Failed to fetch services:", error);
    return null;
  }
};

const FeedbackGreetingScreen = () => {
  const location = useLocation();
  const [feedbackData, setFeedbackData] = useState({ feedback: [], exists: false });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
    const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    let ticketIdFromUrl = queryParams.get("ticketId") ?? queryParams.get("ticketid");

    if (!ticketIdFromUrl && location.state && location.state.ticketId) {
      ticketIdFromUrl = location.state.ticketId;
    }

    if (ticketIdFromUrl) {
      fetchServices(ticketIdFromUrl).then((data) => {
        if (data && data.exists) {
        
          setFeedbackData(data);
        } else {
          setError("No feedback found for this ticket ID");
          navigate(`/thank`);
        }
        setLoading(false);
      });
    } else {
      setError("No ticket ID provided");
      setLoading(false);
    }
  }, [location]);

  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  const { feedback } = feedbackData;

  return (
    <FullScreenContainer>
      <LogoBox>
        <img src="/assets/images/JN_F_Logo.png" alt="Logo" style={{ width: "150px" }} />
      </LogoBox>
      <LandingCurrentDateTime />
      <Container maxWidth="md" sx={{ mt: 10 }}>
        <Root elevation={3}>
          <Box textAlign="center">
            <IconWrapper>
              <CheckCircleOutlineIcon color="primary" style={{ fontSize: 80 }} />
            </IconWrapper>
            <Typography variant="h4" gutterBottom>
              Thank You for Your Feedback!
            </Typography>
            <CustomDivider />
            <Section>
              <Typography variant="body1">
                We appreciate you taking the time to share your thoughts with us.<br></br>
                Your feedback is invaluable and helps us continuously improve
                our services.
              </Typography>
            </Section>
            <CustomRatingDivider />
            {feedback.map((ratingItem, index) => (
              <Box key={index} mb={2}>
                <Grid container spacing={2} >
                  {/* Question */}
                  <Grid item xs={12}>
                    <Typography variant="body1">
                      <strong>{ratingItem.question}</strong>
                    </Typography>
                  </Grid>

                  {/* Rating */}
                  <Grid item xs={12}>
                    <Rating
                      name={`rating-${index}`}
                      value={ratingItem.rating}
                      readOnly
                      style={{ pointerEvents: "none" }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                  
                <Typography variant="body1" align="center">
                  <strong>Comments:</strong>
                  {/* <Box mt={1}> */}
                  {ratingItem.comments}
                  {/* </Box> */}
                </Typography>
                             
                  </Grid>
                 
                </Grid>
              </Box>
            ))}
            {/* Display Comments if available */}
           


            <Section>
              <Typography variant="body1" component="span" fontSize={20} fontWeight="bold">
                Thank you for being a valued customer. Have a great day!
              </Typography>
            </Section>
          </Box>
        </Root>
      </Container>
    </FullScreenContainer>
  );
};

export default FeedbackGreetingScreen;
